import axios from "axios";
import axiosJsonpAdapter from "axios-jsonp";
import router from "@/router";
import proposal from "./proposal";
import customer from "./customer";
import book from "./book";
import myPage from "./mypage";
import contact from "./contact";
import dashboard from "./dashboard";
import org from "./org";
import recruitment from "./recruitment";
import report from "./report";
import policy from "./policy";
import master from "./master";
import components from "./components";

const japanessHolidaysRes = require("./data/japaneseHolidays.json");

const fetch = (mockData, time = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData);
    }, time);
  });
};

const instance = axios.create({
  timeout: 300 * 1000,
  baseURL: "/api"
});

//リクエストをインターセプトして処理する
/*
instance.interceptors.request.use((config) => {
  return config;
});
*/

//レスポンスをインターセプトして処理する
instance.interceptors.response.use(
  (response) => {
    //console.log(response);
    if (response.status && response.status === 200 && response.data.status === 500) {
      alert(response.data.msg);
      return;
    }
    //ファイルダウンロードの場合、responseを丸ごと返す
    if (response.headers["content-disposition"] !== undefined) {
      return response;
    }
    return response.data;
  },
  (error) => {
    //console.log(error);
    window.closeLoading();
    if (error && error.response) {
      if (error.response.status === 404) {
        alert("APIサーバが見つかりませんでした。");
      } else if (error.response.status === 403) {
        alert(error.response.data.msg);
      } else if (error.response.status === 401) {
        alert(error.response.data.msg);
        if (error.response.data.status === 401) {
          router.replace("/");
          //store.state.user.isLoggedIn = false;
        }
      } else if (error.response.status === 500) {
        alert("サーバエラーが発生しました。");
      } else if (error.response.status === 502) {
        alert("サーバエラーが発生しました。");
        router.replace("/");
      } else {
        alert("サーバエラーが発生しました。");
      }
    } else {
      alert("サーバエラーが発生しました。");
    }
    //return Promise.reject(error.response);
    return null;
  }
);

export const request = (config) => {
  return instance.request(config);
};

export default {
  apis: {
    proposal,
    book,
    customer,
    myPage,
    contact,
    dashboard,
    org,
    master,
    report,
    policy,
    recruitment,
    components,
    getApi(vueInstance) {
      if (!vueInstance) {
        return this.common;
      }
      let name = vueInstance.$options.name;
      switch (name) {
        //V001_契約データアップロード画面
        case "PolicyUpload": {
          return this.policy.PolicyUpload;
        }
        // V005_マイページ画面
        case "Mypage":
        case "CommentConfirm":
        case "MyPageRecommendTarget":
        case "RenewalStatusEdit": {
          return this.myPage.MyPageEdit;
        }
        // V006_管理者ダッシュボード画面
        // V006_募集人ダッシュボード画面
        case "ContactBar":
        case "AdminDashboard":
        case "Dashboard":
        case "ApContactStackBar":
        case "ProposalPie":
        case "ProductPie":
        case "ApBar": {
          return this.dashboard.Dashboard;
        }
        //V007_グループスケジュール画面
        case "GroupSchedule": {
          return this.contact.GroupSchedule;
        }
        //V008_最近表示した顧客一覧画面
        case "RecentlyCustomer": {
          return this.customer.RecentlyCustomer;
        }
        //V009_顧客検索・新規登録画面
        case "CustomerSearchResult":
        case "CustomerSearch": {
          return this.customer.CustomerSearch;
        }
        //V010_顧客登録画面
        case "FamilyOwnerSelect":
        case "CustomerEdit": {
          return this.customer.CustomerEdit;
        }
        //V011_顧客情報画面
        case "AttachedDocumentHistory":
        case "RelationalCustomerRegister":
        case "InsuredCustomerSelect":
        case "NearbyCustomerSearchDialog":
        case "RelationalCustomerSearch":
        case "CustomerAllInfo": {
          return this.customer.CustomerAllInfo;
        }
        //V012_世帯構成員検索画面
        case "FamilyMemberSearch":
        case "FamilyMemberSearchResult12": {
          return this.customer.FamilyMemberSearch;
        }
        //V013_世帯構成員登録画面
        case "FamilyMemberEdit": {
          return this.customer.FamilyMemberEdit;
        }
        //V014_顧客名寄せ画面
        case "CustomerUnification": {
          return this.customer.CustomerUnification;
        }
        //V086_送付状作成画面
        case "LetterCreation": {
          return this.customer.LetterCreation;
        }
        //V015_案件詳細表示画面
        case "ProposalAllInfo":
        case "ProposalAttachment":
        case "ProposalTodo":
        case "ProposalHistory":
        case "RelatedProposal":
        case "RelatedProposalEdit": {
          return this.proposal.ProposalAllInfo;
        }
        //V016_意向把握シート画面
        //V016-1_当初意向・最新の意向登録画面
        case "IntentHearing":
        case "IntentHearingIntentionProduct":
        case "IntentHearingDialog":
        case "IntentHearingOriginalEdit":
        case "IntentHearingLastIntentEdit": {
          return this.proposal.IntentHearing;
        }
        //V017_意向把握シート（最終確認）画面
        case "IntentConfirm":
        case "IntentConfirmSign":
        case "IntentConfirmDialog":
        case "IntentConfirmReturnDialog": {
          return this.proposal.IntentConfirm;
        }
        //V018_提案商品登録画面
        case "ProposalProductEdit": {
          return this.proposal.ProposalProductEdit;
        }
        //V019 証券情報
        case "PolicyEdit":
        case "PolicyEditSpecialContractEdit":
        case "PolicyEditSelectInsuredCustomer": {
          return this.policy.policyEdit;
        }
        //V020_対応予定・対応履歴登録
        case "ContactEdit": {
          return this.contact.ContactEdit;
        }
        //V021_予定・対応漏れ一覧画面
        case "LeakContact":
        case "LeakContactResult": {
          return this.contact.LeakContact;
        }
        //V022_案件検索画面
        case "ProposalSearch":
        case "ProposalSearchResult":
        case "ProposalSearchMultipleEdit":
        case "ProposalSearchDueMultipleEdit": {
          return this.proposal.ProposalSearch;
        }
        //V024_対応履歴検索画面
        case "ContactSearch":
        case "CommentEditDialog": {
          return this.contact.ContactSearch;
        }
        //V025_日報登録・確認画面
        case "DailyReportEdit":
        case "DailyReportCommonSpecialAffair": {
          return this.report.DailyReportEdit;
        }
        //V026_日報検索・コメント入力画面
        case "DailyReportComment":
        case "DailyReportCommonComment": {
          return this.report.DailyReportComment;
        }
        //V027_最近表示した団体一覧画面
        case "RecentlyOrg": {
          return this.org.RecentlyOrg;
        }
        // V028_団体検索・新規登録画面
        case "OrgSearch": {
          return this.org.OrgSearch;
        }
        // V029_団体情報画面
        case "OrgAllInfo":
        case "OrgAllInfoAttachment": {
          return this.org.OrgAllInfo;
        }
        // V030_団体登録画面
        case "OrgEdit": {
          return this.org.OrgEdit;
        }
        // V031_団体第2階層・第3階層情報画面
        case "OrgSecondThirdLevelInfo": {
          return this.org.OrgSecondThirdLevelInfo;
        }
        // V032_団体第2階層・第3階層登録画面
        case "OrgSecondThirdLevelEdit": {
          return this.org.OrgSecondThirdLevelEdit;
        }
        // V035_団体対応予定・対応履歴登録画面
        case "OrgContactEdit": {
          return this.contact.OrgContactEdit;
        }
        // V036_募集企画登録画面
        case "RecruitmentPlanEdit": {
          return this.recruitment.RecruitmentPlanEdit;
        }
        // V037_募集企画一覧画面
        case "RecruitmentPlanList": {
          return this.recruitment.RecruitmentPlanList;
        }
        // V038_募集企画対象者一覧画面
        case "RecruitmentPlanTargetList":
        case "RecruitmentPlanTargetListResult":
        case "RecruitmentPlanTargetListPasswordDialog": {
          return this.recruitment.RecruitmentPlanTargetList;
        }
        // V039_顧客条件抽出画面
        case "RecruitmentTargetExtract":
        case "RecruitmentTargetExtractDialog":
        case "RecruitmentTargetExtractResult":
        case "RecruitmentTargetExtractPasswordDialog": {
          return this.recruitment.RecruitmentTargetExtract;
        }
        //V040_案件一括登録画面
        case "ProposalBatchCreation": {
          return this.recruitment.ProposalBatchCreation;
        }
        // V041成績・見込み集計画面
        case "PerformanceSummaryReport": {
          return this.report.PerformanceSummaryReport;
        }
        // V042成約一覧・集計表作成画面
        case "SignedContractSummaryReport": {
          return this.report.SignedContractSummaryReport;
        }
        // V043接点集計表画面
        case "ContactSummaryReport": {
          return this.report.ContactSummaryReport;
        }
        // V044解約集計表画面
        case "CancelSummaryReport": {
          return this.report.CancelSummaryReport;
        }
        // V045苦情等集計表画面
        case "ClaimSummaryReport": {
          return this.report.ClaimSummaryReport;
        }
        // V047_個人データ管理台帳画面
        case "PersonalInfoBook":
        case "PersonalInfoBookDialog": {
          return this.book.PersonalInfoBook;
        }
        // V048_個人データ登録画面
        case "PersonalInfoBookEdit": {
          return this.book.PersonalInfoBookEdit;
        }
        //V050_アクセス履歴一覧画面
        case "AppAccessLog": {
          return this.book.AppAccessLog;
        }
        //V051_ユーザマスタ
        case "UserMaster":
        case "UserMasterEdit": {
          return this.master.UserMaster;
        }
        //V052_出先・部署マスタ画面
        case "BranchMaster":
        case "BranchMasterBranchEdit":
        case "BranchMasterDepartmentEdit": {
          return this.master.BranchMaster;
        }
        //V053_担当者別目標マスタ画面
        case "UserPerformanceGoal":
        case "UserPerformanceGoalResult": {
          return this.master.UserPerformanceGoal;
        }
        //V055_顧客分類マスタ画面
        case "CustomerKind": {
          return this.master.CustomerKindMaster;
        }
        //V056_団体分類マスタ画面
        case "OrgKind": {
          return this.master.OrgKindMaster;
        }
        //V057_保険会社マスタ画面
        case "InsuranceCorpMaster": {
          return this.master.InsuranceCorpMaster;
        }
        //V058_保険商品マスタ画面
        case "ProductMasterDialog":
        case "ProductMaster": {
          return this.master.ProductMaster;
        }
        //V059_受付経路マスタ画面
        case "PathMaster": {
          return this.master.PathMaster;
        }
        //V060_対応種別マスタ画面
        case "ContactKind": {
          return this.master.ContactKindMaster;
        }
        //V061_対応履歴定型文マスタ画面
        case "ContactSample": {
          return this.master.ContactSampleMaster;
        }
        //V062_添付種類マスタ画面
        case "AttachmentKind": {
          return this.master.AttachmentKindMaster;
        }
        //V063_個人データ種類マスタ画面
        case "PersonalInfoKind": {
          return this.master.PersonalInfoKindMaster;
        }
        //V064_ご希望の保障分野マスタ画面
        case "IntentHearingItem": {
          return this.master.IntentHearingItemMaster;
        }
        //V065_お客様のご意向マスタ画面
        case "RecommendationReason": {
          return this.master.RecommendationReasonMaster;
        }
        //V066_ご意向の振り返りマスタ画面
        case "IntentConfirmItem": {
          return this.master.IntentConfirmItemMaster;
        }
        //V067_案件アクション設計画面
        case "ProcessDesign":
        case "ProcessDesignNewEdit":
        case "ProcessDesignOldEdit":
        case "ProcessDesignDueEdit": {
          return this.master.ProcessDesign;
        }
        //V072_システム推奨募集対象担当未割振一覧画面
        case "PICNotAssignedTarget":
        case "PICNotAssignedTargetResult": {
          return this.recruitment.PICNotAssignedTarget;
        }
        //V074_持出管理台帳画面
        case "BringOutBook":
        case "BringOutBookResult": {
          return this.book.BringOutBook;
        }
        //V075_持出情報登録画面
        case "BringOutBookEdit": {
          return this.book.BringOutBookEdit;
        }
        //V076_発送履歴台帳画面
        case "SendBook":
        case "SendBookResult": {
          return this.book.SendBook;
        }
        //V077_発送履歴登録画面
        case "SendBookEdit": {
          return this.book.SendBookEdit;
        }
        //V078_受領履歴台帳
        case "ReceiveBook":
        case "ReceiveBookResult": {
          return this.book.ReceiveBook;
        }
        //V079_受領履歴台帳登録
        case "ReceiveBookEdit": {
          return this.book.ReceiveBookEdit;
        }
        //V080_マニュアル画面
        case "Manual": {
          return this.components.Manual;
        }
        //V081_案件基本情報登録画面
        case "ProposalBasicInfoEdit": {
          return this.proposal.ProposalBasicInfoEdit;
        }
        //V082_案件プロセス登録画面
        case "ProposalProcessEdit": {
          return this.proposal.ProposalProcessEdit;
        }
        //V083_添付ファイル登録画面
        case "ProposalAttachmentEdit": {
          return this.proposal.ProposalAttachmentEdit;
        }
        //V084_保険特約マスタ画面
        case "ProductSpecialEditDialog":
        case "SpecialContractEditDialog":
        case "SpecialContract": {
          return this.master.SpecialContractMaster;
        }
        //V085_募集企画対象者区分マスタ画面
        case "CampaignCustomerCategory": {
          return this.master.CampaignCustomerCategory;
        }
        //V087_送付書類マスタ画面
        case "Letter": {
          return this.master.Letter;
        }
        //V088_送付状挨拶文マスタ画面
        case "Greeting": {
          return this.master.Greeting;
        }
        //V089_社内予定登録
        case "MySchedule": {
          return this.contact.MySchedule;
        }
        //V090_ファイル出力ログ画面
        case "FileDownloadLog": {
          return this.book.FileDownloadLog;
        }
        //V091_パフォーマンス管理表
        case "PerformanceManagementReport": {
          return this.report.PerformanceManagementReport;
        }
        //V092_適合性確認項目マスタ
        case "SuitabilityItem":
        case "SuitabilityItemEdit":
        case "SuitabilitySubItemEdit": {
          return this.master.SuitabilityItem;
        }
        //V093_証券検索画面
        case "PolicySearch":
        case "PolicySearchResult":
        case "PolicySearchRenewalStatusEdit": {
          return this.policy.PolicySearch;
        }
        //V094_TNet契約種目データアップロード画面
        case "TNetContractItemDataUpload": {
          return this.policy.TNetContractItemDataUpload;
        }
        // V095 損保証券情報
        case "PolicyEditSonpo": {
          return this.policy.policyEditSonpo;
        }
        //V096_満期更改案件一括登録画面
        case "DueProposalBatchCreation": {
          return this.proposal.DueProposalBatchCreation;
        }
        //V097_更改後商品登録画面
        case "RenewalProductEdit": {
          return this.policy.RenewalProductEdit;
        }
        //V098_意向把握シート検索画面
        case "IntentConfirmSearch":
        case "IntentConfirmSearchResult":
        case "IntentConfirmSearchReturnDialog": {
          return this.proposal.IntentConfirmSearch;
        }
        //V200_担当者選択画面
        case "PICSelect": {
          return this.components.PICSelect;
        }
        //V201_団体選択画面
        case "OrgSelect": {
          return this.components.OrgSelect;
        }
        //V202_募集企画選択画面
        case "RecruitmentPlanSelect": {
          return this.components.RecruitmentPlanSelect;
        }
        //V203_団体第2階層選択画面
        case "OrgTwoSelect": {
          return this.components.OrgTwoSelect;
        }
        //V204_団体第3階層選択画面
        case "OrgThreeSelect": {
          return this.components.OrgThreeSelect;
        }
      }
    },
    getJapaneseHolidays() {
      return fetch(japanessHolidaysRes, 100);
    },
    getPRImages() {
      return request({
        url: "/pr/prImages",
        method: "get"
      });
    },
    login(params) {
      return request({
        url: "/login",
        data: params,
        method: "post"
      });
    },
    changePassword(params) {
      return request({
        url: "/user/updatePassword",
        data: params,
        method: "post"
      });
    },
    setupDevice() {
      return request({
        url: "/mfa/setup",
        method: "get"
      });
    },
    saveDevice(params) {
      return request({
        url: "/mfa/save",
        data: params,
        method: "post"
      });
    },
    deleteDevice(params) {
      return request({
        url: "/mfa/delete",
        data: params,
        method: "post"
      });
    },
    verify(params) {
      return request({
        url: "/mfa/verify",
        data: params,
        method: "post"
      });
    },
    logout() {
      return request({
        url: "/logout",
        method: "get"
      });
    },
    getNotice() {
      return request({
        url: "/notice/list",
        method: "get"
      });
    },
    readNotice(params) {
      return request({
        url: "/notice/read",
        data: params,
        method: "post"
      });
    },
    getMessage(params) {
      return request({
        url: "/message/find",
        data: params,
        method: "post"
      });
    },
    addMessage(params) {
      return request({
        url: "/message/add",
        data: params,
        method: "post"
      });
    },
    updateMessage(params) {
      return request({
        url: "/message/update",
        data: params,
        method: "post"
      });
    },
    deleteMessage(params) {
      return request({
        url: "/message/delete",
        data: params,
        method: "post"
      });
    },
    searchAddressInfo(url) {
      let config = {
        adapter: axiosJsonpAdapter,
        method: "get",
        url: url
      };
      return axios(config);
    },
    makeRemoteSignUrl(params) {
      return request({
        url: "/intentConfirm/makeRemoteSignUrl",
        data: params,
        method: "post"
      });
    },
    getSignature(params) {
      return request({
        url: "/intentConfirm/getSignature",
        data: params,
        method: "post"
      });
    },
    getProposalNoFromUrl(params) {
      console.log(params);
      return request({
        url: "/remoteIntentConfirm/getProposalNoFromUrl",
        data: params,
        method: "post"
      });
    },
    remoteIntentConfirm(params) {
      return request({
        url: "/remoteIntentConfirm/remoteIntentConfirm",
        data: params,
        method: "post"
      });
    },
    saveSignature(params) {
      return request({
        url: "/remoteIntentConfirm/saveSignature",
        data: params,
        method: "post"
      });
    }
  }
};
